export default __webpack_public_path__ + "static/media/regular-service-icon.10ce319b.svg";